import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.webhooks || initialState;

const makeSelectList = () =>
  createSelector(select, subState => subState.webhooksList);

const makeSelectCountList = () =>
  createSelector(select, subState => subState.count);

const makeSelectLoading = () =>
  createSelector(select, subState => subState.loading);

const makeSelectError = () =>
  createSelector(select, subState => subState.error);

export default select;
export {
  makeSelectList,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectError,
};
